export const filterJornada = (norturno: boolean) => {
    return (_: any, index: number, array: any[]) => {
        if (index === 0) {
            return false
        } else if (!norturno) {
            return index !== array.length - 1
        } else {
            return true
        }
    }
}
